<div class="header-container">
    <span class="fs-20px font-weight-bold text-white">Detalle de <b>{{skuInfo!.sku}}</b></span>
    <span class="text-white fs-16px" style="cursor: pointer;" (click)="closeDialog()">
        <i class="fa-solid fa-square-xmark"></i>
    </span>
</div>

<table class="table table-striped">

    <tbody>
      <tr>
        <td class="align-middle ">
          <b>Sku</b>
        </td>
        <td class="align-middle ">
          {{skuInfo?.sku}}
        </td>
      </tr>
      <tr>
        <td class="align-middle ">
          <b>Descripción</b>
        </td>
        <td class="align-middle ">
          {{skuInfo?.descripcion}}
        </td>
      </tr>
      <tr>
        <td class="align-middle ">
          <b>Marca</b>
        </td>
        <td class="align-middle ">
          {{skuInfo?.marca}}
        </td>
      </tr>
      <tr>
        <td class="align-middle ">
          <b>Modelo</b>
        </td>
        <td class="align-middle ">
          {{skuInfo?.modelo}}
        </td>
      </tr>
      <tr>
        <td class="align-middle ">
          <b>Tipo Clasificación</b>
        </td>
        <td class="align-middle ">
          {{skuInfo?.clasificacion}}
        </td>
      </tr>
      <tr>
        <td class="align-middle ">
          <b>Alto</b>
        </td>
        <td class="align-middle ">
          {{skuInfo?.alto}}
        </td>
      </tr>
      <tr>
        <td class="align-middle ">
          <b>Ancho</b>
        </td>
        <td class="align-middle ">
          {{skuInfo?.ancho}}
        </td>
      </tr>
      <tr>
        <td class="align-middle ">
          <b>Rin</b>
        </td>
        <td class="align-middle ">
          {{skuInfo?.rin}}
        </td>
      </tr>
      
    </tbody>
</table>